import React from 'react';

interface Props {
    title: React.ReactNode;
    description: React.ReactNode;
    eyebrow?: string;
    actions?: React.ReactNode;
}

/** Shared heading rhythm from the farmacia appearance preview, in CO MARCA colors. */
export default function AdminPageHeader({ title, description, eyebrow = 'CO MARCA GROUP', actions }: Props) {
    return (
        <header className="vx-page-heading">
            <div>
                <span className="vx-section-kicker">{eyebrow}</span>
                <h1>{title}</h1>
                <p>{description}</p>
            </div>
            {actions && <div className="vx-page-actions">{actions}</div>}
        </header>
    );
}
